<template>
  <div class="box full">
    <div class="box-header">
      HTML for marketplace
    </div>
    <div class="box-content-block">
      <div class="mb-4 grid grid-cols-2 overflow-hidden break-all">
        <div>
          <button
            :class="[
              marketplace == 'amazon' ? 'btn-success-button' : 'btn-dark-button'
            ]"
            @click="marketplace = 'amazon'"
          >
            Amazon
          </button>
          <button
            :class="[
              marketplace == 'ebay' ? 'btn-success-button' : 'btn-dark-button'
            ]"
            @click="marketplace = 'ebay'"
          >
            eBay
          </button>
        </div>
        <div></div>
      </div>
      <div class="w-full grid grid-cols-2 gap-2">
        <div class="border-r-2 border-dark-300 overflow-hidden break-all">
          {{ htmlMarketplace }}
        </div>
        <div v-html="htmlMarketplace" id="rendered"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { getApplications } from "@/api/store/ApplicationsService.js";
import { getHtmlMarketplace as getHtmlMarketplaceApi } from "@/api/store/MarketplacesItemsService.js";

export default {
  name: "MarketplacesHtml",
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      productApplications: [],
      marketplace: "ebay",
      ebayHtml: ""
    };
  },
  computed: {
    htmlMarketplace() {
      if (this.marketplace == "ebay") {
        return this.ebayHtml;
      }
      let body = `<div class='container-listing'>Code: <b>${this.product.part.nkrCode}</b></br></br>`;
      body += `<b>${this.product.part.title}</b></br></br>`;
      body += `<b>Brand</b>: ${this.product.part.brand}</br></br>`;

      if (this.product.part.keywords && this.product.part.keywords !== "") {
        body += `Keywords: ${this.product.part.keywords}</br></br>`;
      }

      if (
        this.product.part.longDescription &&
        this.product.part.longDescription !== ""
      ) {
        body += `Description: ${this.product.part.longDescription}</br></br>`;
      }

      body += `This is a " Brand New " quality item. Many more Isuzu truck parts in stock, contact us for further assistance.</br></br>`;

      if (this.product.attributes.length == 1) {
        body += "<b>Attribute</b>: ";
      }
      if (this.product.attributes.length > 1) {
        body += "<b>Attributes</b>:</br></br>";
      }
      this.product.attributes.forEach(attribute => {
        body += `${attribute.attributeName}: ${attribute.value}</br></br>`;
      });
      if (this.product.categories.length == 1) {
        body += "<b>Category</b>: ";
      }
      if (this.product.categories.length > 1) {
        body += "<b>Categories</b>:</br></br>";
      }
      this.product.categories.forEach(category => {
        body += `${category.categoryName} - ${category.subCategoryName}</br></br>`;
      });

      if (this.productApplications.length > 0) {
        body += "<b>Fitment</b>:</br></br>";
      }
      let table = "";

      this.productApplications.forEach(application => {
        table += `Make: ${application.make} -
          Model: ${application.model} -
          From year: ${application.minyear} -
          To year: ${application.maxyear} -
          Engine: ${application.engineName}(${application.engineLiter})</br></br>`;
      });

      return body + table;
    }
  },
  mounted() {
    this.getApplications(this.product.part.unificado);
    this.getHtmlMarketplace(this.product.part.nkrCode);
  },
  methods: {
    getHtmlMarketplace(nkrCode) {
      getHtmlMarketplaceApi(nkrCode).then(res => {
        this.ebayHtml = res.html;
      });
    },
    async getApplications(unificado) {
      this.productApplications = await getApplications(unificado);
    }
  }
};
</script>
